<template>
  <div>
    <el-dialog
      title="订单详情"
      :visible.sync="value"
      width="40%"
      :before-close="orderDetailsClose"
      :close-on-click-modal="false"
    >
      <div>
        会员姓名:{{
          orderInfo.memberName
        }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;创建人:{{
          orderInfo.createUserName
        }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;结算人:{{ orderInfo.updateUser }}
      </div>
      <div class="underline mb15 disFlex">
        <div>
          订单编号：<span>{{ orderInfo.orderNumber }}</span>
        </div>
        <div class="ml155">
          创建时间：<span>{{ orderInfo.createDate }}</span>
        </div>
        <div class="ml155">
          结算时间：<span>{{ orderInfo.updateDate }}</span>
        </div>
      </div>
      <div class="underline mb15">
        <div class="allmoney">
          <div class="mb15">
            <span class="text">总金额：</span>
            <span>{{ orderInfo.totalMoney }}元</span
            ><i class="el-icon-arrow-down" @click="blockDetails" v-if="disb"></i
            ><i class="el-icon-arrow-up" @click="blockDetails" v-if="!disb"></i>
          </div>
          <div v-if="disb" class="ml45 mb15">
            <div
              v-for="item in orderInfo.antOrderMiscellaneousList"
              :key="item.name"
              class="mb15"
            >
              {{ item.name }}：<span class="ml15">{{ item.money }}元</span>
              <div>备注：{{ item.remarks }}</div>
            </div>
            <div v-if="orderInfo.archeryPriceTotal">
              射箭：<span class="ml15">
                {{ orderInfo.archeryPriceTotal }}元</span
              >
            </div>
            <div v-if="orderInfo.followPriceTotal">
              随行：<span class="ml15">
                {{ orderInfo.followPriceTotal }}元</span
              >
            </div>
          </div>
          <div class="mb15">
            <span class="text">会员抵扣：</span>
            <span
              ><span v-if="orderInfo.realityMoney">-</span
              >{{ orderInfo.realityMoney }}元</span
            >
          </div>
          <div class="mb15">
            <span class="text"> 减免：</span>
            <span
              ><span v-if="orderInfo.reduceMoney">-</span
              >{{ orderInfo.reduceMoney }}元</span
            >
          </div>
          <div class="mb15">
            <span class="text"> 应结算：</span>
            <span>{{ orderInfo.actualAmount }}元</span>
          </div>
        </div>
      </div>

      <div class="underline mb15">
        <div class="mb15">箭票射箭</div>
        <div class="clearingBoxs mb15">
          <div v-for="item in arrowPaymentMethodList" :key="item.text">
            <span class="needwidth1">{{ item.text }}：</span>
            <span>{{ item.payMoney ? item.payMoney : 0 }}</span>
            <span class="ml5">组</span>
          </div>
        </div>
        <div class="mb15">储值射箭</div>
        <div class="clearingBoxs mb15">
          <div v-for="(item, index) in storedPaymentMethodList" :key="index">
            <span class="needwidth1">{{ item.text }}：</span>
            <span>{{ item.payMoney ? item.payMoney : 0 }}</span>
            <span v-if="item.text != '饮料消费'">组</span>
            <span v-if="item.text != '饮料消费'" class="jisuan">{{
              item.moneyTranslation ? item.moneyTranslation : "0元"
            }}</span>
            <span v-if="item.text == '饮料消费'">元</span>
          </div>
        </div>
      </div>
      <!--  -->
      <div
        class="underline mb15"
        v-if="storedBalancePaymentMethodList.length > 0"
      >
        <div class="mb15">储值赠储消费</div>
        <div class="clearingBoxs mb15">
          <div v-for="item in storedBalancePaymentMethodList" :key="item.text">
            <span class="needwidth1">{{ item.paymentMethod }}：</span>
            <span>{{ item.moneyTranslation }}</span>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="underline mb15">
        <div class="mb15">结算方式</div>
        <div class="othermoney mb15">
          <div
            class="mb15"
            v-for="item in orderInfo.otherPaymentMethodList"
            :key="item.paymentMethod"
          >
            <span v-if="item.paymentMethod != '减免'" class="texts">
              {{ item.paymentMethod }}：</span
            >
            <span v-if="item.paymentMethod != '减免'"
              >{{ item.payMoney }}元</span
            >
          </div>
          <div>
            <span class="texts"> 合计：</span>
            <span class="colorRed"> {{ orderInfo.actualAmount }}元</span>
          </div>
        </div>
      </div>
      <div>备注：{{ orderInfo.remarks }}</div>
      <div style="display: flex" v-if="orderInfo.orderPhoto">
        <div>订单图片：</div>
        <div><img :src="globelurls + orderInfo.orderPhoto" alt="" /></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="orderDetailsClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/OrderManagement.js";
import { globelurl } from "../../api/axios";
export default {
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.getOrderDetail();
        }
      },
    },
  },
  props: {
    value: {
      type: Boolean,
    },
    orderId: {
      type: String,
    },
  },
  data() {
    return {
      globelurls: globelurl,
      disb: false,
      orderInfo: {},
      arrowPaymentMethodList: [
        //箭票射箭
        {
          payMoney: "",
          text: "箭票",
          paymentMethod: "arrow_ticket",
          type: "arrowVolume",
        },
        {
          payMoney: "",
          text: "有赞箭票",
          paymentMethod: "have_great_arrow_ticket",
          type: "none",
        },
        {
          payMoney: "",
          text: "纸质箭票",
          paymentMethod: "paper_arrow_ticket",
          type: "none",
        },
        {
          payMoney: "",
          text: "电子卡",
          paymentMethod: "electronic_card",
          type: "electronicCard",
        },
        {
          payMoney: "",
          text: "有赞电子卡",
          paymentMethod: "have_great_electronic_card",
          type: "none",
        },
      ],
      storedPaymentMethodList: [
        //储值射箭
        {
          payMoney: "",
          text: "储值消费",
          paymentMethod: "balance_consume",
          moneyTranslation: "",
        },
        {
          payMoney: "",
          text: "赠储消费",
          paymentMethod: "give_store_consume",
          moneyTranslation: "",
        },
        {
          payMoney: "",
          text: "饮料消费",
          paymentMethod: "drinks_consume",
          moneyTranslation: "",
        },
        {
          payMoney: "",
          text: "随行储值消费",
          paymentMethod: "follow_balance_consume",
          moneyTranslation: "",
        },
        {
          payMoney: "",
          text: "随行赠储消费",
          paymentMethod: "follow_give_store_consume",
          moneyTranslation: "",
        },
      ],
      storedBalancePaymentMethodList: [],
    };
  },

  methods: {
    orderDetailsClose() {
      this.$emit("input", false);
      this.arrowPaymentMethodList = [
        //箭票射箭
        {
          payMoney: "",
          text: "箭票",
          paymentMethod: "arrow_ticket",
          type: "arrowVolume",
        },
        {
          payMoney: "",
          text: "有赞箭票",
          paymentMethod: "have_great_arrow_ticket",
          type: "none",
        },
        {
          payMoney: "",
          text: "纸质箭票",
          paymentMethod: "paper_arrow_ticket",
          type: "none",
        },
        {
          payMoney: "",
          text: "电子卡",
          paymentMethod: "electronic_card",
          type: "electronicCard",
        },
        {
          payMoney: "",
          text: "有赞电子卡",
          paymentMethod: "have_great_electronic_card",
          type: "none",
        },
      ];
      this.storedPaymentMethodList = [
        //储值射箭
        {
          payMoney: "",
          text: "储值消费",
          paymentMethod: "balance_consume",
          moneyTranslation: "",
        },
        {
          payMoney: "",
          text: "赠储消费",
          paymentMethod: "give_store_consume",
          moneyTranslation: "",
        },
        {
          payMoney: "",
          text: "饮料消费",
          paymentMethod: "drinks_consume",
          moneyTranslation: "",
        },
        {
          payMoney: "",
          text: "随行储值消费",
          paymentMethod: "follow_balance_consume",
          moneyTranslation: "",
        },
        {
          payMoney: "",
          text: "随行赠储消费",
          paymentMethod: "follow_give_store_consume",
          moneyTranslation: "",
        },
      ];
    },
    getNum() {
      if (
        this.orderInfo.arrowPaymentMethodList &&
        this.orderInfo.arrowPaymentMethodList.length >= 1
      ) {
        this.arrowPaymentMethodList.map((itm) => {
          this.orderInfo.arrowPaymentMethodList.map((ele) => {
            if (itm.text == ele.paymentMethod) {
              itm.payMoney = ele.payMoney;
            }
          });
        });
      }
      if (
        this.orderInfo.storedPaymentMethodList &&
        this.orderInfo.storedPaymentMethodList.length >= 1
      ) {
        this.storedPaymentMethodList.map((itm) => {
          this.orderInfo.storedPaymentMethodList.map((ele) => {
            if (itm.text == ele.paymentMethod) {
              itm.payMoney = ele.payMoney;
              itm.moneyTranslation = ele.moneyTranslation;
            }
          });
        });
      }
      if (
        this.orderInfo.storedBalancePaymentMethodList &&
        this.orderInfo.storedBalancePaymentMethodList.length >= 1
      ) {
        this.storedBalancePaymentMethodList =
          this.orderInfo.storedBalancePaymentMethodList;
      } else {
        this.storedBalancePaymentMethodList = [];
      }
    },
    getOrderDetail() {
      getOrderDetail({ id: this.orderId }).then((res) => {
        // console.log(res, "订单详情");
        if (res.status === 200 && res.data.success) {
          this.orderInfo = res.data.result;
          this.getNum();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    blockDetails() {
      this.disb = !this.disb;
    },
  },
};
</script>
<style scoped>
.underline {
  border-bottom: 1px solid #ccc;
}
.disFlex {
  display: flex;
}
.mb15 {
  margin-bottom: 15px;
}
.mb20 {
  margin-bottom: 20px;
}
.ml45 {
  margin-left: 45px;
}
.ml20 {
  margin-left: 20px;
}
.vipclearing {
  margin-left: 30px;
  display: flex;
  margin-bottom: 15px;
}
.clearingBox {
  display: flex;
  flex-wrap: wrap;
  margin-left: 50px;
}
.clearingBoxs {
  display: flex;
  flex-wrap: wrap;
  margin-left: 30px;
}
.clearingBoxs > div {
  width: 31%;
  margin-left: 8px;
}
.allmoney {
  margin-left: 70%;
  margin-top: 10px;
}
.othermoney {
  margin-left: 75%;
}
.colorRed {
  color: red;
}
.jisuan {
  display: inline-block;
  margin-left: 15px;
}
.needwidth1 {
  display: inline-block;
  width: 105px;
}
.text {
  display: inline-block;
  width: 80px;
}
.texts {
  display: inline-block;
  width: 60px;
}
.ml155 {
  margin-left: 15px;
}
</style>